export default __webpack_public_path__ + "static/media/shanchu.2344d622.png";